<template>
  <div class="clockrank">
    <div class="main">
      <div class="banner-wrap">
        <div class="banner-img">
          <el-image :src="bannerInfo.banner" fit="cover" style="width: 100%;height: 100%;"></el-image>
        </div>
        <div class="title">{{ activityInfo.title }}</div>
        <div class="descript l_flex_row">
          <div class="des-item">关注数：{{ bannerInfo.member_num }}</div>
          <div class="des-item">社团数：{{ bannerInfo.organize_num }}</div>
          <div class="des-item">机构数：{{ bannerInfo.group_num }}</div>
        </div>
        <div class="navbar l_flex_row">
          <div :class="{ active: currentNav == 1 }" class="nav-item l_flex_row_center" @click="navChange(1)">
            <i class="iconfont icon-yuedujilu"></i>
            <span class="icon-name">阅读书籍</span>
          </div>
          <div :class="{ active: currentNav == 0 }" class="nav-item l_flex_row_center" @click="navChange(0)">
            <i class="iconfont icon-paixing"></i>
            <span class="icon-name">打卡排行</span>
          </div>

          <div :class="{ active: currentNav == 2 }" class="nav-item l_flex_row_center" @click="navChange(2)">
            <i class="iconfont icon-wode"></i>
            <span class="icon-name">我的阅读</span>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>


export default {
  name: "clockRank",
  components: {

  },
  props: {
    activityId: {
      type: String,
    },
  },
  data() {
    return {
      currentNav: 0,
      bannerInfo: {},
      activityInfo: {},
    };
  },
  watch: {
    $route: {
      handler(newval, oldval) {
        console.log("watch router", newval);
        let nav = newval.meta.nav;
        let rules = {
          rank: 0,
          read: 1,
          my: 2,
          agencies: 3,
        };
        this.currentNav = rules[nav];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    navChange(e) {
      // console.log("navchange", e);
      this.currentNav = e;
      const navRule = {
        0: "/clock/rank",
        1: "/clock/read",
        2: "/clock/my",
        3: "/clock/agencies",
      };
      this.$router.replace({
        path: navRule[e],
        query: {
          id: this.$route.query.id,
          title: this.title,
        },
      });
    },
    async init() {
      try {
        let data = {
          params: {
            "access-token": localStorage.getItem("token"),
            activity_id: this.activityId,
          },
          data: {},
        };
        let res = await this.$api.getClockActivityBanner(data);
        this.bannerInfo = res.data;
        console.log("success", res);
      } catch (e) {
        console.log("error", e);
      }
    },
    // 获取活动信息
    async getActivityInfo() {
      //
      try {
        const res = await this.$api.getActivityDetail({
          params: {
            id: this.activityId,
          },
        });
        this.activityInfo = res.data;
        sessionStorage.setItem("activityInfo", JSON.stringify(res.data));
        // 活动未开始， 跳转到活动详情
        if (this.activityInfo.status == 2) {
          this.$router.replace({
            path: "/activitydetail",
            query: {
              id: this.activityInfo.id,
            },
          });
          this.$message({
            message: "活动未开始",
            offset:300,
            duration:2000
          });
        }
      } catch (error) {
        console.error("err", error);
      }
    },
  },
  created() {
    console.log("打卡页面", this.$route.query, this.activityId);
    this.init();
    this.getActivityInfo();
  },
};
</script>

<style lang="scss" scoped>
.clockrank {
  .main {
    width: 1200px;
    margin: 40px auto;

    .banner-wrap {
      overflow: hidden;
      border-radius: 10px;
      box-shadow: 0 0 4px 4px #eee;
      background-color: #fff;
      .banner-img {
        height: 350px;
        width: 100%;
        background-color: #0acc81;
      }

      .title {
        padding: 30px 20px;
        font-weight: bold;
        font-size: 20px;
      }

      .descript {
        padding: 0 20px;

        .des-item {
          margin-right: 30px;
          font-size: 14px;
          color: #b7b7b7;
        }
      }

      .navbar {
        padding: 20px 20px;

        .nav-item {
          width: 200px;
          height: 50px;
          background-color: #eeeeee;
          color: #999999;
          margin-right: 30px;
          border-radius: 5px;
          cursor: pointer;

          &.active {
            background-color: #815a4e;
            color: #fff;

            .iconfont {
              color: #fff;
            }

            .icon-name {
              color: #fff;
            }
          }

          .iconfont {
            color: #999999;
            margin-right: 10px;
            display: inline-block;
          }

          .icon-name {
            display: inline-block;
            color: #999999;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
